import { apiCall } from "@/shared/services/apiCall.js";
import { errorToast, successToast, helper } from "@/shared/services/helper";
import dateTime from "@/shared/services/dateTime.js";
import store  from "@/store/index";

const getUserAccounts = async (payment_methods, reconnectTry = 0) => {
    let responseObj = {
        withdrawAccountType: null,
        userAccounts: [],
        paymentMethods: []
    }
    try{
        store.dispatch('setGlobalLoader', true);
        let response = await apiCall('get', 'ACCOUNT_DETAILS', null, 'wallet')
        store.dispatch('setGlobalLoader', false);
        if (!response?.data?.success) {
            errorToast(response.data.message);
        }else{
            if(Boolean(response.data.data.is_bank_only)) {
                console.log(responseObj.account_list);
                
                responseObj.userAccounts = response.data.data.account_list.filter(pm => pm.payment_method == 'bank')?.sort(
                    (a, b) => dateTime.currentTimestamp(b.created_at) - dateTime.currentTimestamp(a.created_at)
                );
            } else {
                responseObj.userAccounts = responseObj.userAccounts = response.data.data.account_list.sort(
                (a, b) => dateTime.currentTimestamp(b.created_at) - dateTime.currentTimestamp(a.created_at));
            }
        } 
        return responseObj;
    }catch(error){
        store.dispatch('setGlobalLoader', false);
        if(reconnectTry < 3 && !error) {
            getUserAccounts(reconnectTry + 1);
        }
        else {
            if (error) {
                errorToast(error[0]);
            }
        }
    }
};

const removeAccount = async (id) => {
    try{
        let response = await apiCall('delete', 'DELETE_ACCOUNT',{}, 'wallet', {accountId: id})
        if (!response?.data?.success) {
            errorToast(response.data.message);
            return false
        }else{
            successToast(response?.data?.message);
            return true
        } 
    }catch(error){
        errorToast(error[0]);
        return false
    }
};

const withdrawAmountClickValidation = async (withdrawAmount, walletConfig, withdrawlBalance) => {
    try{
        if (withdrawAmount == null || +withdrawAmount < +walletConfig?.withdrawal_range?.min) {
            errorToast('Please enter amount greater than equal to ' + walletConfig?.withdrawal_range?.min);
            return false
        } 
        else if(+withdrawAmount > +withdrawlBalance) {
            errorToast('Insufficient Balance');
            return false
        }
        else{
            return true
        }
        
    }catch(error){
        console.log(error)
        return false
    }
};

const withdrawWalletAmount = async (withdrawAmount, accountId) => {
    try {
        store.dispatch('setGlobalLoader', true);
        
        let data = {
            "amount": withdrawAmount,
            "client_account_index": accountId,
            // "client_created_date": dateTime.sportItemDate(accountDetails.created_at, 'YYYY-MM-DD HH:mm:ss'),
            "type": "client_withdrawal"
        }

        let response = await apiCall('post', 'GET_ID_WALLET_WITHDRAW', data);
        store.dispatch('setGlobalLoader', false);
        if (response.data.error) {
            errorToast(response.data.error);
            return { error : response.data.error}
        }else{
            successToast(response?.data?.message)
            return true
        } 
    } catch (error) {
        store.dispatch('setGlobalLoader', false);
        if (error) {
            errorToast(error);
            return { error : error }
        }
    }
}
export {
    getUserAccounts,
    removeAccount,
    withdrawAmountClickValidation,
    withdrawWalletAmount
}